import { Box, Button, IconButton, Modal, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { English } from "../../constant/EnglishFallback";
const LocationMessageModal = (props) => {
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const userId = loginData?.userInformation?.UserId;

  const LanguageData = multiLanguageData?.RewardStore || {};
  const {
    TEXT_REWARD_LOCATION = English.RewardStore.TEXT_REWARD_LOCATION,
    TEXT_LOCATION_VERIFY_HEADER = English.RewardStore.TEXT_LOCATION_VERIFY_HEADER,
    TEXT_LOCATION_VERIFY_SUB_HEADER1 = English.RewardStore.TEXT_LOCATION_VERIFY_SUB_HEADER1,
    TEXT_LOCATION_VERIFY_SUB_HEADER2 = English.RewardStore.TEXT_LOCATION_VERIFY_SUB_HEADER2,
    TEXT_BACK_TO_DASHBOARD = English.RewardStore.TEXT_BACK_TO_DASHBOARD,
    TEXT_GO_TO_PROFILE = English.RewardStore.TEXT_GO_TO_PROFILE
  } = LanguageData || {};

  const navigate = useNavigate();
  const goToDashboard = () => {
    navigate("/home");
  };
  const goToProfile = () => {
    navigate(`/${userId}`);
  };

  return (
    <Modal open={props?.open}>
      <Box className="user-modal-responsive">
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between"
          }}>
          <Typography variant="h6">{TEXT_REWARD_LOCATION}</Typography>
          <Stack flexDirection={"row"}>
            <IconButton onClick={goToProfile}>
              <CloseIcon />
            </IconButton>
          </Stack>
        </Box>
        <Stack alignItems={"center"}>
          <Typography variant="subtitle1" color="error">
            {TEXT_LOCATION_VERIFY_HEADER}
          </Typography>
          <Typography variant="subtitle1">{TEXT_LOCATION_VERIFY_SUB_HEADER1}</Typography>
          <Typography variant="subtitle1">{TEXT_LOCATION_VERIFY_SUB_HEADER2}</Typography>
        </Stack>
        <Stack direction={"row"} spacing={5} pt={2}>
          <Button variant="outlined" fullWidth onClick={goToDashboard}>
            {TEXT_BACK_TO_DASHBOARD}
          </Button>
          <Button variant="outlined" fullWidth onClick={goToProfile}>
            {TEXT_GO_TO_PROFILE}
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default LocationMessageModal;
